import axiosIns from "./axios";

export const GET_EMPLOYEE = (args) => {
    return axiosIns.get(`/employee?${args}`);
};

export const ADD_EMPLOYEE = (args) => {
    return axiosIns.post(`/employee`, args);
};

export const GET_EMPLOYEE_BY_ID = (args) => {
    return axiosIns.get(`/employee/roles?${args}`);
};
export const DELETE_USER_ROLE = (clientId, payload) => {
    return axiosIns.delete(`/role-management/client-roles/${clientId}/user`, {
        data: payload
    });
};
